// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8230) return "static/chunks/8230-d6f88f10f3a952f9.js";
	if (chunkId === 813) return "static/chunks/813-5e1d66e71911b4c9.js";
	if (chunkId === 4587) return "static/chunks/4587-50be220e90439163.js";
	if (chunkId === 6845) return "static/chunks/6845-45711bc7bead0533.js";
	if (chunkId === 3636) return "static/chunks/3636-1f8a48e0e03b7784.js";
	if (chunkId === 3716) return "static/chunks/98309536-6f75991e3ca8786c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"939":"e1fa16f1c7758b39","1262":"d8987e5b40d3f43a","1978":"05e9644b9e4e2f33","3793":"9272330ecd6e6e62","4408":"bd023abafbd864f3","4847":"8dd37d9fac7398e2","5201":"2f5b5ab0d35b426c","6998":"2caf0292aad69aa1","7506":"8a264050fb30d680","8522":"d3a9f4e61441bbcc","9293":"79bc131e688e8062"}[chunkId] + ".js";
};